import React, { useEffect, useRef, useState } from "react";
import "./ContactUs.css";
import axios from "axios";
import { AiOutlineCheckCircle } from "react-icons/ai";
import Nav from "../Home/navbar/nav";
import { Helmet } from "react-helmet";
import IndianFlag from "../Media/indian.png";
import "react-phone-input-2/lib/style.css";

const ContactUs = () => {
  const phoneInputRef = useRef(null);
  const locations = [
    {
      id: "india",
      flagSrc: IndianFlag, // place your flag image here
      flagEmoji: "🇮🇳",
      country: "INDIA",
      addressLines: [
        "6/483 C, Fathima Road East,",
        "Azhagappapuram, Kanyakumari District,",
        "Tamil Nadu - 629401.",
      ],
      gmap: "#",
      contacts: [
        { title: "Sales Enquiry", email: "sales@althisolutions.com" },
        { title: "HR Enquiry", email: "hr@althisolutions.com" },
      ],
    },
    // {
    //   id: "usa",
    //   flagSrc: USAFlag,
    //   flagEmoji: "🇺🇸",
    //   country: "USA",
    //   addressLines: ["1200 Ford Rd, Farmers Branch,", "Texas - 75234."],
    //   gmap: "#",
    //   contacts: [
    //     { title: "Sales Enquiry", email: "sales@althisolutions.com" },
    //     { title: "HR Enquiry", email: "hr@althisolutions.com" },
    //   ],
    // },
  ];

const countries = [
  { name: "Afghanistan", code: "+93", maxLength: 9 },
  { name: "Aland Islands", code: "+358", maxLength: 10 },
  { name: "Albania", code: "+355", maxLength: 9 },
  { name: "Algeria", code: "+213", maxLength: 9 },
  { name: "AmericanSamoa", code: "+1684", maxLength: 7 },
  { name: "Andorra", code: "+376", maxLength: 9 },
  { name: "Angola", code: "+244", maxLength: 9 },
  { name: "Anguilla", code: "+1264", maxLength: 7 },
  { name: "Antarctica", code: "+672" },
  { name: "Antigua and Barbuda", code: "+1268", maxLength: 7 },
  { name: "Argentina", code: "+54", maxLength: 11 },
  { name: "Armenia", code: "+374", maxLength: 8 },
  { name: "Aruba", code: "+297", maxLength: 7 },
  { name: "Australia", code: "+61", maxLength: 9 },
  { name: "Austria", code: "+43", maxLength: 13 },
  { name: "Azerbaijan", code: "+994", maxLength: 9 },
  { name: "Bahamas", code: "+1242", maxLength: 7 },
  { name: "Bahrain", code: "+973", maxLength: 8 },
  { name: "Bangladesh", code: "+880", maxLength: 10 },
  { name: "Barbados", code: "+1246", maxLength: 7 },
  { name: "Belarus", code: "+375", maxLength: 9 },
  { name: "Belgium", code: "+32", maxLength: 9 },
  { name: "Belize", code: "+501", maxLength: 7 },
  { name: "Benin", code: "+229", maxLength: 8 },
  { name: "Bermuda", code: "+1441", maxLength: 7 },
  { name: "Bhutan", code: "+975", maxLength: 8 },
  { name: "Bolivia, Plurinational State of", code: "+591", maxLength: 8 },
  { name: "Bosnia and Herzegovina", code: "+387", maxLength: 9 },
  { name: "Botswana", code: "+267", maxLength: 8 },
  { name: "Brazil", code: "+55", maxLength: 11 },
  { name: "British Indian Ocean Territory", code: "+246", maxLength: 7 },
  { name: "Brunei Darussalam", code: "+673", maxLength: 7 },
  { name: "Bulgaria", code: "+359", maxLength: 9 },
  { name: "Burkina Faso", code: "+226", maxLength: 8 },
  { name: "Burundi", code: "+257", maxLength: 8 },
  { name: "Cambodia", code: "+855", maxLength: 9 },
  { name: "Cameroon", code: "+237", maxLength: 9 },
  { name: "Canada", code: "+1", maxLength: 10 },
  { name: "Cape Verde", code: "+238", maxLength: 7 },
  { name: "Cayman Islands", code: "+345", maxLength: 7 },
  { name: "Central African Republic", code: "+236", maxLength: 8 },
  { name: "Chad", code: "+235", maxLength: 8 },
  { name: "Chile", code: "+56", maxLength: 9 },
  { name: "China", code: "+86", maxLength: 11 },
  { name: "Colombia", code: "+57", maxLength: 10 },
  { name: "Comoros", code: "+269", maxLength: 7 },
  { name: "Congo", code: "+242", maxLength: 9 },
  { name: "Congo, The Democratic Republic of the Congo", code: "+243", maxLength: 9 },
  { name: "Cook Islands", code: "+682", maxLength: 5 },
  { name: "Costa Rica", code: "+506", maxLength: 8 },
  { name: "Cote d'Ivoire", code: "+225", maxLength: 10 },
  { name: "Croatia", code: "+385", maxLength: 9 },
  { name: "Cuba", code: "+53", maxLength: 8 },
  { name: "Cyprus", code: "+357", maxLength: 8 },
  { name: "Czech Republic", code: "+420", maxLength: 9 },
  { name: "Denmark", code: "+45", maxLength: 8 },
  { name: "Djibouti", code: "+253", maxLength: 8 },
  { name: "Dominica", code: "+1767", maxLength: 7 },
  { name: "Dominican Republic", code: "+1849", maxLength: 7 },
  { name: "Ecuador", code: "+593", maxLength: 9 },
  { name: "Egypt", code: "+20", maxLength: 10 },
  { name: "El Salvador", code: "+503", maxLength: 8 },
  { name: "Equatorial Guinea", code: "+240", maxLength: 9 },
  { name: "Eritrea", code: "+291", maxLength: 7 },
  { name: "Estonia", code: "+372", maxLength: 10 },
  { name: "Ethiopia", code: "+251", maxLength: 9 },
  { name: "Falkland Islands (Malvinas)", code: "+500", maxLength: 5 },
  { name: "Faroe Islands", code: "+298", maxLength: 6 },
  { name: "Fiji", code: "+679", maxLength: 7 },
  { name: "Finland", code: "+358", maxLength: 10 },
  { name: "France", code: "+33", maxLength: 9 },
  { name: "French Guiana", code: "+594", maxLength: 9 },
  { name: "French Polynesia", code: "+689", maxLength: 6 },
  { name: "Gabon", code: "+241", maxLength: 8 },
  { name: "Gambia", code: "+220", maxLength: 7 },
  { name: "Georgia", code: "+995", maxLength: 9 },
  { name: "Germany", code: "+49", maxLength: 13 },
  { name: "Ghana", code: "+233", maxLength: 9 },
  { name: "Gibraltar", code: "+350", maxLength: 8 },
  { name: "Greece", code: "+30", maxLength: 10 },
  { name: "Greenland", code: "+299", maxLength: 6 },
  { name: "Grenada", code: "+1473", maxLength: 7 },
  { name: "Guadeloupe", code: "+590", maxLength: 9 },
  { name: "Guam", code: "+1671" , maxLength: 7 },
  { name: "Guatemala", code: "+502", maxLength: 8 },
  { name: "Guernsey", code: "+44", maxLength: 10 },
  { name: "Guinea", code: "+224", maxLength: 9 },
  { name: "Guinea-Bissau", code: "+245", maxLength: 7 },
  { name: "Guyana", code: "+592", maxLength: 7 },
  { name: "Haiti", code: "+509", maxLength: 8 },
  { name: "Holy See (Vatican City State)", code: "+379", maxLength: 10 },
  { name: "Honduras", code: "+504", maxLength: 8 },
  { name: "Hong Kong", code: "+852", maxLength: 9 },
  { name: "Hungary", code: "+36", maxLength: 9 },
  { name: "Iceland", code: "+354", maxLength: 9 },
  { name: "India", code: "+91", maxLength: 10 },
  { name: "Indonesia", code: "+62", maxLength: 11 },
  { name: "Iran, Islamic Republic of Persian Gulf", code: "+98", maxLength: 10 },
  { name: "Iraq", code: "+964", maxLength: 10 },
  { name: "Ireland", code: "+353", maxLength: 9 },
  { name: "Isle of Man", code: "+44", maxLength: 10 },
  { name: "Israel", code: "+972", maxLength: 9 },
  { name: "Italy", code: "+39", maxLength: 11 },
  { name: "Jamaica", code: "+1876", maxLength: 7 },
  { name: "Japan", code: "+81", maxLength: 10 },
  { name: "Jersey", code: "+44", maxLength: 10 },
  { name: "Jordan", code: "+962", maxLength: 9 },
  { name: "Kazakhstan", code: "+7", maxLength: 10 },
  { name: "Kenya", code: "+254", maxLength: 9 },
  { name: "Kiribati", code: "+686", maxLength: 8 },
  { name: "Korea, Democratic People's Republic of Korea", code: "+850", maxLength: 10 },
  { name: "Korea, Republic of South Korea", code: "+82", maxLength: 10 },
  { name: "Kuwait", code: "+965", maxLength: 8 },
  { name: "Kyrgyzstan", code: "+996", maxLength: 9 },
  { name: "Laos", code: "+856", maxLength: 9 },
  { name: "Latvia", code: "+371", maxLength: 8 },
  { name: "Lebanon", code: "+961", maxLength: 8 },
  { name: "Lesotho", code: "+266", maxLength: 8 },
  { name: "Liberia", code: "+231", maxLength: 7 },
  { name: "Libyan Arab Jamahiriya", code: "+218", maxLength: 9 },
  { name: "Liechtenstein", code: "+423", maxLength: 9 },
  { name: "Lithuania", code: "+370", maxLength: 8 },
  { name: "Luxembourg", code: "+352", maxLength: 9 },
  { name: "Macao", code: "+853", maxLength: 8 },
  { name: "Macedonia", code: "+389", maxLength: 8 },
  { name: "Madagascar", code: "+261", maxLength: 9 },
  { name: "Malawi", code: "+265", maxLength: 9 },
  { name: "Malaysia", code: "+60", maxLength: 10 },
  { name: "Maldives", code: "+960", maxLength: 7 },
  { name: "Mali", code: "+223", maxLength: 8 },
  { name: "Malta", code: "+356" , maxLength: 8 },
  { name: "Marshall Islands", code: "+692", maxLength: 7 },
  { name: "Martinique", code: "+596", maxLength: 9 },
  { name: "Mauritania", code: "+222", maxLength: 8 },
  { name: "Mauritius", code: "+230", maxLength: 7 },
  { name: "Mayotte", code: "+262", maxLength: 9 },
  { name: "Mexico", code: "+52", maxLength: 10 },
  { name: "Micronesia, Federated States of Micronesia", code: "+691", maxLength: 7 },
  { name: "Moldova", code: "+373", maxLength: 8 },
  { name: "Monaco", code: "+377", maxLength: 8 },
  { name: "Mongolia", code: "+976", maxLength: 8 },
  { name: "Montenegro", code: "+382", maxLength: 8 },
  { name: "Montserrat", code: "+1664", maxLength: 7 },
  { name: "Morocco", code: "+212", maxLength: 9 },
  { name: "Mozambique", code: "+258", maxLength: 9 },
  { name: "Myanmar", code: "+95", maxLength: 9 },
  { name: "Namibia", code: "+264", maxLength: 9 },
  { name: "Nauru", code: "+674", maxLength: 7 },
  { name: "Nepal", code: "+977", maxLength: 10 },
  { name: "Netherlands", code: "+31", maxLength: 9 },
  { name: "Netherlands Antilles", code: "+599", maxLength: 8 },
  { name: "New Caledonia", code: "+687", maxLength: 6 },
  { name: "New Zealand", code: "+64", maxLength: 9 },
  { name: "Nicaragua", code: "+505", maxLength: 8 },
  { name: "Niger", code: "+227", maxLength: 8 },
  { name: "Nigeria", code: "+234", maxLength: 10 },
  { name: "Niue", code: "+683", maxLength: 4 },
  { name: "Northern Mariana Islands", code: "+1670", maxLength: 7 },
  { name: "Norway", code: "+47", maxLength: 8 },
  { name: "Oman", code: "+968", maxLength: 8 },
  { name: "Pakistan", code: "+92", maxLength: 10 },
  { name: "Palau", code: "+680", maxLength: 7 },
  { name: "Palestinian Territory, Occupied", code: "+970", maxLength: 9 },
  { name: "Panama", code: "+507", maxLength: 8 },
  { name: "Papua New Guinea", code: "+675", maxLength: 8 },
  { name: "Paraguay", code: "+595", maxLength: 9 },
  { name: "Peru", code: "+51", maxLength: 9 },
  { name: "Philippines", code: "+63", maxLength: 10 },
  { name: "Pitcairn", code: "+872", maxLength: 7 },
  { name: "Poland", code: "+48", maxLength: 9 },
  { name: "Portugal", code: "+351", maxLength: 9 },
  { name: "Puerto Rico", code: "+1939", maxLength: 7 },
  { name: "Qatar", code: "+974", maxLength: 8 },
  { name: "Romania", code: "+40", maxLength: 9 },
  { name: "Russia", code: "+7", maxLength: 10 },
  { name: "Rwanda", code: "+250", maxLength: 9 },
  { name: "Reunion", code: "+262", maxLength: 9 },
  { name: "Saint Barthelemy", code: "+590", maxLength: 9 },
  { name: "Saint Helena, Ascension and Tristan Da Cunha", code: "+290", maxLength: 5 },
  { name: "Saint Kitts and Nevis", code: "+1869", maxLength: 7 },
  { name: "Saint Lucia", code: "+1758", maxLength: 7 },
  { name: "Saint Martin", code: "+590", maxLength: 9 },
  { name: "Saint Pierre and Miquelon", code: "+508", maxLength: 6 },
  { name: "Saint Vincent and the Grenadines", code: "+1784", maxLength: 7 },
  { name: "Samoa", code: "+685", maxLength: 7 },
  { name: "San Marino", code: "+378", maxLength: 10 },
  { name: "Sao Tome and Principe", code: "+239", maxLength: 7 },
  { name: "Saudi Arabia", code: "+966", maxLength: 9 },
  { name: "Senegal", code: "+221", maxLength: 9 },
  { name: "Serbia", code: "+381", maxLength: 9 },
  { name: "Seychelles", code: "+248", maxLength: 7 },
  { name: "Sierra Leone", code: "+232", maxLength: 8 },
  { name: "Singapore", code: "+65", maxLength: 8 },
  { name: "Slovakia", code: "+421", maxLength: 9 },
  { name: "Slovenia", code: "+386", maxLength: 9 },
  { name: "Solomon Islands", code: "+677", maxLength: 7 },
  { name: "Somalia", code: "+252", maxLength: 8 },
  { name: "South Africa", code: "+27", maxLength: 9 },
  { name: "South Sudan", code: "+211", maxLength: 9 },
  { name: "South Georgia and the South Sandwich Islands", code: "+500", maxLength: 5 },
  { name: "Spain", code: "+34", maxLength: 9 },
  { name: "Sri Lanka", code: "+94", maxLength: 9 },
  { name: "Sudan", code: "+249", maxLength: 9 },
  { name: "Suriname", code: "+597", maxLength: 7 },
  { name: "Svalbard and Jan Mayen", code: "+47", maxLength: 8 },
  { name: "Swaziland", code: "+268", maxLength: 8 },
  { name: "Sweden", code: "+46", maxLength: 9 },
  { name: "Switzerland", code: "+41", maxLength: 9 },
  { name: "Syrian Arab Republic", code: "+963", maxLength: 9 },
  { name: "Taiwan", code: "+886", maxLength: 9 },
  { name: "Tajikistan", code: "+992", maxLength: 9 },
  { name: "Tanzania, United Republic of Tanzania", code: "+255", maxLength: 9 },
  { name: "Thailand", code: "+66", maxLength: 9 },
  { name: "Timor-Leste", code: "+670", maxLength: 7 },
  { name: "Togo", code: "+228", maxLength: 8 },
  { name: "Tokelau", code: "+690", maxLength: 4 },
  { name: "Tonga", code: "+676", maxLength: 5 },
  { name: "Trinidad and Tobago", code: "+1868", maxLength: 7 },
  { name: "Tunisia", code: "+216", maxLength: 8 },
  { name: "Turkey", code: "+90", maxLength: 10 },
  { name: "Turkmenistan", code: "+993", maxLength: 8 },
  { name: "Turks and Caicos Islands", code: "+1649", maxLength: 7 },
  { name: "Tuvalu", code: "+688", maxLength: 5 },
  { name: "Uganda", code: "+256", maxLength: 9 },
  { name: "Ukraine", code: "+380", maxLength: 9 },
  { name: "United Arab Emirates", code: "+971", maxLength: 9 },
  { name: "United Kingdom", code: "+44", maxLength: 10 },
  { name: "United States", code: "+1", maxLength: 10 },
  { name: "Uruguay", code: "+598", maxLength: 8 },
  { name: "Uzbekistan", code: "+998", maxLength: 9 },
  { name: "Vanuatu", code: "+678", maxLength: 7 },
  { name: "Venezuela, Bolivarian Republic of Venezuela", code: "+58", maxLength: 10 },
  { name: "Vietnam", code: "+84", maxLength: 9 },
  { name: "Virgin Islands, British", code: "+1284", maxLength: 7 },
  { name: "Virgin Islands, U.S.", code: "+1340", maxLength: 7 },
  { name: "Wallis and Futuna", code: "+681", maxLength: 6 },
  { name: "Yemen", code: "+967", maxLength: 9 },
  { name: "Zambia", code: "+260", maxLength: 9 },
  { name: "Zimbabwe", code: "+263", maxLength: 9 }
];
const [currentMaxDigits, setCurrentMaxDigits] = useState(10); // Defaults to 10 digits
const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    organization: "",
    region: "",
    message: "",
    countryCode: "",
    nationalNumber: "",
    fullNumber: "",
  });

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;

  const textOnlyFields = ["fullName", "organization", "region", "message"];

  if (textOnlyFields.includes(name)) {
    const onlyText = value.replace(/[^a-zA-Z\s]/g, "");
    setFormData({
      ...formData,
      [name]: onlyText,
    });
  } else if (name === "phone") {
    const numericAndPlus = value.replace(/[^0-9+\s]/g, "");
    setFormData({
      ...formData,
      [name]: numericAndPlus,
    });
  } else {
    setFormData({
      ...formData,
      [name]: value,
    });
  }
};

useEffect(() => {
  const handleOutsideClick = () => setIsOpen(false);
  window.addEventListener('click', handleOutsideClick);
  return () => window.removeEventListener('click', handleOutsideClick);
}, [])

 

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

const handleSubmit = (e) => {
  e.preventDefault();

  const apiURL = process.env.REACT_APP_CONTACTUS_HOST;

  const hasPhoneInput = formData.phone && formData.phone.trim() !== "";

  if (
    formData.fullName &&
    formData.organization &&
    formData.message &&
    formData.email &&
    formData.region &&
    hasPhoneInput
  ) {
    
    let countryCode = "";
    let nationalNumber = "";
    
    if (formData.phone.includes(" ")) {
      const parts = formData.phone.split(" ");
      countryCode = parts[0]; 
      nationalNumber = parts.slice(1).join("");
    } else {
      nationalNumber = formData.phone;
    }

    const payload = {
      fullName: formData.fullName,
      email: formData.email,
      organization: formData.organization,
      region: formData.region,
      phone: formData.phone, 
      message: formData.message,
    };

    axios
      .post(apiURL, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setShowSuccessMessage(true);

        setFormData({
          fullName: "",
          email: "",
          organization: "",
          region: "",
          phone: "", 
          message: "",
        });

        setTimeout(() => {
          setShowSuccessMessage(false);
        }, 3000);
      })
      .catch((error) => {
        console.error("API Error context:", error);
      });
  } else {
    console.warn("Validation failed: Please ensure all required fields are filled out.");
  }
};

  return (
    <>
      <div className="w-full ">
        <Helmet>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title>Contact Us</title>
          <meta
            name="description"
            content="We're here to help with your next step in digital success."
          />
          <link
            rel="canonical"
            href="https://www.althisolutions.com/contactus"
          />
          <meta name="robots" content="index, follow" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Contact Us" />
          <meta
            property="og:url"
            content="https://www.althisolutions.com/contactus"
          />
          <meta
            property="og:image"
            content="https://althisolutions.com/static/media/Contactus-bg.5453882e5eb86b6b57e7.jpg"
          />
          <meta
            property="og:description"
            content="We're here to help with your next step in digital success."
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Contact Us" />
          <meta name="twitter:site" content="@Althisolutions" />
          <meta
            name="twitter:description"
            content="We're here to help with your next step in digital success."
          />
          <meta
            name="twitter:image"
            content="https://althisolutions.com/static/media/Contactus-bg.5453882e5eb86b6b57e7.jpg"
          />
        </Helmet>

        <Nav />

        <div className="contactus-section-banner aln_Pos">
          <div className="contact-overlay">
            {/* <div className='container'> */}
            <div
              className="contactus-section-overlay flex"
              style={{ height: "auto", padding: "134px 25px" }}
            >
              <div className="max_Width w-full">
                <div className="contactus-section-banner-content-section">
                  <div className="contactus-section-banner-form">
                    <div className="contactus-form">
                      <h2>Let's Talk</h2>
                      <div className="contact-form-container">
                        <form className="contact-form" onSubmit={handleSubmit}>
                          <div className="form-row">
                              <div className="form-group half">
                              <label
                                className="contact-form-label"
                                htmlFor="fullName"
                              >
                                Full Name
                              </label>
                              <input
                                type="text"
                                id="fullName"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>

                          {/* Email */}
                          <div className="form-group">
                            <label
                              className="contact-form-label"
                              htmlFor="email"
                            >
                              Email
                            </label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              required
                            />
                          </div>

                        <div 
                          className="form-group" 
                          style={{ position: 'relative' }}
                          onClick={(e) => e.stopPropagation()} 
                        >
                          <label className="contact-form-label" htmlFor="phone">
                            Phone Number
                          </label>
                          
                          <input
                            type="text"
                            id="phone"
                            name="phone"
                            ref={phoneInputRef}
                            className="contact-form-input"
                            value={formData.phone || ''}
                            onClick={() => setIsOpen(true)} 
                            onChange={handleChange}
                            placeholder=""
                            maxLength={
                            formData.phone && formData.phone.includes(' ') 
                              ? formData.phone.split(' ')[0].length + 1 + currentMaxDigits 
                              : 15
                          }
                            style={{
                              background: 'transparent',
                              border: 'none',
                              borderBottom: '2px solid #fff', 
                              color: '#fff',
                              width: '100%',
                              padding: '8px 0',
                              outline: 'none'
                            }}
                            required
                          />

                          {isOpen && (
                            <ul className="country-dropdown custom-scrollbar" style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              zIndex: 1000,
                              width: '100%',
                              maxHeight: '160px',
                              overflowY: 'auto',
                              backgroundColor: 'rgba(20, 20, 20, 0.98)', 
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              borderRadius: '4px',
                              listStyle: 'none',
                              padding: 0,
                              margin: '4px 0 0 0',
                              boxShadow: '0 8px 16px rgba(0,0,0,0.5)'
                            }}>
                              {countries.map((country, index) => (
                                <li 
                                  key={index} 
                                  onClick={() => {
                                    handleChange({
                                      target: {
                                        name: 'phone',
                                        value: `${country.code} `
                                      }
                                    });
                                    
                                    setIsOpen(false); 
                                    
                                    setTimeout(() => {
                                      if (phoneInputRef.current) {
                                        phoneInputRef.current.focus();
                                      }
                                    }, 0);
                                  }}
                                  style={{
                                    padding: '10px',
                                    cursor: 'pointer',
                                    color: '#fff',
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                    fontSize: '14px'
                                  }}
                                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                >
                                  {country.name} ({country.code})
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>

                          {/* Organization + Region */}
                          <div className="form-row">
                            <div className="form-group half">
                              <label
                                className="contact-form-label"
                                htmlFor="organization"
                              >
                                Organization
                              </label>
                              <input
                                type="text"
                                id="organization"
                                name="organization"
                                value={formData.organization}
                                onChange={handleChange}
                                required
                              />
                            </div>
                            <div className="form-group half">
                              <label
                                className="contact-form-label"
                                htmlFor="region"
                              >
                                Region
                              </label>
                              <input
                                type="text"
                                id="region"
                                name="region"
                                value={formData.region}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>

                          {/* Message */}
                          <div className="form-group">
                            <label
                              className="contact-form-label"
                              htmlFor="message"
                            >
                              How Can We Help You...
                            </label>
                            <input
                              id="message"
                              name="message"
                              value={formData.message}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          {/* Submit */}
                          <div className="form-group submit-group">
                            <button type="submit">Submit</button>
                          </div>
                        </form>
                      </div>
                    </div>
                    {showSuccessMessage && (
                      <div className="success-messages">
                        <div className="success-message-contents">
                          <div className="success-message-headings">
                            Submitted Successfully !
                          </div>
                          <AiOutlineCheckCircle className="check-icon"></AiOutlineCheckCircle>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="contactus-section-banner-content ">
                    <h1 className="">Request for Service</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="locations-section">
          <div className="container">
            <h2 className="locations-title">Our Locations</h2>
            <p className="locations-sub">
              From questions about pricing to personalized one-on-one demos,
              we’re here to help you get started.
            </p>

            <div className="locations-list">
              {locations.map((loc) => (
                <article className="location-row" key={loc.id}>
                  {/* LEFT SIDE */}
                  <div className="location-left">
                    <div className="flag-and-name">
                      {loc.flagSrc ? (
                        <img
                          src={loc.flagSrc}
                          alt={loc.country ? `${loc.country} flag` : "Country flag"}
                          className="flag-image"
                        />
                      ) : (
                        <div className="flag-emoji">{loc.flagEmoji}</div>
                      )}
                      <h3 className="country-name-flag">{loc.country}</h3>
                    </div>

                    <address className="address-block">
                      {loc.addressLines.map((line, idx) => (
                        <div key={idx}>{line}</div>
                      ))}
                    </address>

                    <a
                      className="gmap-link"
                      href={loc.gmap}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="pin">📍</span>
                      <span>Reach Us</span>
                    </a>
                  </div>

                  {/* RIGHT SIDE */}
                  <div className="location-right">
                    {loc.contacts.map((c, i) => (
                      <div className="contact-card" key={i}>
                        <div className="avatar-placeholder" aria-hidden="true">
                          👤
                        </div>
                        <div className="contact-right">
                          <h4 className="contact-title">{c.title}</h4>
                          <a
                            className="contact-email"
                            href={`mailto:${c.email}`}
                          >
                            {c.email}
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactUs;
